import { render, staticRenderFns } from "./CardOrder.vue?vue&type=template&id=1c21b904&scoped=true&"
import script from "./CardOrder.vue?vue&type=script&lang=js&"
export * from "./CardOrder.vue?vue&type=script&lang=js&"
import style0 from "./CardOrder.vue?vue&type=style&index=0&id=1c21b904&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c21b904",
  null
  
)

export default component.exports